import { HelpOutlineOutlined, QuestionAnswerOutlined } from '@mui/icons-material'
import { Button, Typography } from '@mui/material'
import Inquiry from 'app/EgretLayout/SharedCompoents/Inquiry'
import { HELP_CASE_TYPES } from 'app/services/sfAuth/sfData/sfCase'
import { ButtonIcon } from 'app/views/common-components/ButtonIcon'
import { useState } from 'react'

const caseTypeToIcon = {
  HELP: HelpOutlineOutlined,
  CONTACT_US: QuestionAnswerOutlined,
  FUNDING_UNSURE: QuestionAnswerOutlined
}

export const FormInquiry = ({
  title,
  typeProps,
  preview,
  disabled,
  ...props
}): JSX.Element => {
  const { variant, color, type = null } = typeProps
  const [inquiryOpen, openInquiry] = useState(false)

  return (
    <div>
      <Inquiry
        selectCaseType={type === 'CONTACT_US'}
        open={inquiryOpen}
        handleClose={() => openInquiry(false)}
        caseType={HELP_CASE_TYPES[type]}
        selectCaseLocation={type === 'FUNDING_UNSURE'}
      />
      <Button
        fullWidth
        color={color ?? 'primary'}
        variant={variant ?? 'contained'}
        onClick={e => {
          openInquiry(true)
        }}
      >
        <Typography>
          {title}
        </Typography>
        <ButtonIcon IconClass={caseTypeToIcon[type] || QuestionAnswerOutlined} />
      </Button>
    </div>
  )
}
